export default query => `<p class="search-no-results">No results for <strong>${query}</strong></p>`;
